import { render, staticRenderFns } from "./DialogEmailAddUserGroup.vue?vue&type=template&id=4a96ef2c&"
import script from "./DialogEmailAddUserGroup.vue?vue&type=script&lang=js&"
export * from "./DialogEmailAddUserGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports